<template>
    <div>
        <div class="px-2 py-3">
            <CompanyInfo
                class="block-item bg-grey2 p-3"
                ref="companyInfo"
                @file-uploaded = "fileUploaded">   
            </CompanyInfo>

            <BusinessAddress
            class="block-item bg-grey2 p-3"
            ref="businessAddress"
            @file-uploaded = "fileUploaded">

            </BusinessAddress>

            <RegisteredAddress
            ref="registeredAddress"
            class="block-item bg-grey2 p-3"
            @file-uploaded = "fileUploaded">
            </RegisteredAddress>

            <div class="mb-5 block-item bg-grey2 p-3">
                <div class="d-flex">
                    <h5>{{ $t('Director Information') }}</h5>
                </div>
                
                <div class="mb-3 mt-3">
                    <div v-for="(item,index) in director_list" :key="item.id">
                        <InterDirectorInfo
                            :ref="'director'+item.id"
                            @file-uploaded = "fileUploaded"
                            :doc_type_list = document
                            :is_remove = "director_list.length>1?true:false">
                        </InterDirectorInfo>
                        <div class="d-flex justify-content-end mb-4">
                            <div class="ml-auto d-flex">
                                <button v-if="director_list.length>1" class="d-flex align-items-center btn btn-outline-red" @click="removeItemDirector(item.id)">
                                    <span>Remove</span>
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </button>
                                <button class="btn btn-outline-orange" @click="addDirector">{{ $t('Add') }} +</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            
            <div class="mb-3 block-item bg-grey2 p-3">
                <div class="d-flex">
                    <h5>{{ $t('Beneficiary Information') }}</h5>
                    <span class="position-relative">
                        <button type="button" class="flat-button position-absolute" @click="togglePopup()">
                        <img :src="`${publicPath}/img/rcp/icon/btn-info.png`" class="align-top">
                        </button>
                        <NewPopupInfo :name="'beneficiary'" v-if="showPopup"></NewPopupInfo>
                    </span>
                </div>
                <hr class="m-0">
                
                <div class="p-3 mb-3 mt-3">
                    <div v-for="(item,index) in beneficary_list" :key="item.id">
                        
                        <InterBeneficiaryInfo 
                            :ref="'beneficiary'+item.id"
                            @file-uploaded = "fileUploaded"
                            :doc_type_list = document
                            :is_remove = "beneficary_list.length>1?true:false"
                        ></InterBeneficiaryInfo>
                        
                        <div class="d-flex justify-content-end mb-2 mt-2">
                            <div class="mb-0">
                                
                                <div class="w-100 ml-auto d-flex justify-content-end mb-3">
                                    <button v-if="beneficary_list.length>1" class="d-flex align-items-center btn btn-outline-red" @click="removeItem(item.id)">
                                        <span>Remove</span>
                                        <i class="fa fa-trash" aria-hidden="true"></i>
                                    </button>
                                    <button class="btn btn-outline-orange" @click="addBeneficiary">Add +</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr>
            <div  class="form-group text-justify">
                <label :for="agree" id="agree" class="d-flex align-items-start justify-content-center">
                    <input v-model="agree" type="checkbox" autocomplete="off" @change="onChange('agree')" class="mt-2">
                    <span class="ml-4 w-100 fz-14">
                        <p><i>{{ $t('agreement-1') }}</i></p>
                        <p><i>{{ $t('agreement-2') }}</i></p>
                        <p><i>{{ $t('agreement-3') }}</i></p>
                    </span>
                </label>
                <div v-if="error.agree" class="text-danger d-block">
                    {{$t(error.agree)}}
                </div>
            </div>
            <TakePicture :ref="'take-picture'" @take-photo="takePhoto($event)"></TakePicture>
            <div class="text-right mt-3">
                <button class="btn btn-primary" @click="submitAccount">{{ $t('Submit') }}</button>
            </div>

            <LoaderComponent v-if="isLoading"></LoaderComponent>
        </div>
    </div>  
</template>

  <script>
    import TakePicture from "@/components/Kyc/TakePicture";
    import LoaderComponent from "@/components/LoaderComponent";
    import CompanyInfo from '@/components/CardManagement/companyInfo.vue';
    import BusinessAddress from '@/components/CardManagement/businessAddress.vue';
    import RegisteredAddress from "@/components/CardManagement/registeredAddress.vue";
    import InterDirectorInfo from "@/components/CardManagement/interDirectorInfo.vue";
    import InterBeneficiaryInfo from "@/components/CardManagement/interBeneficiaryInfo.vue";

    import CreateAccount from '@/services/CreateAccount';
    import NewPopupInfo from '@/components/NewPopupInfo.vue';

    export default {
        name: 'international',
        data() {
            return {
                publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
                nationality:'',
                showPopup:false,
                agree:'',
                beneficary_list:[{"id":1}],
                director_list:[{"id":1}],
                isDisabled:false,
                isLoading:false,
                company_info:{},
                business_address:{},
                registered_address:{},
                director_data:[],
                beneficary_data:[],
                document:[
                    {
                        "id":1,
                        "name":"Identity Card"
                    },
                    {
                        "id":2,
                        "name":"Passport"
                    }
                ],
                error:{
                    agree:''
                }
            }
        },
        components: {
            TakePicture,
            CompanyInfo,
            BusinessAddress,
            RegisteredAddress,
            InterDirectorInfo,
            InterBeneficiaryInfo,
            LoaderComponent,
            NewPopupInfo
        },
        methods:{
            addDirector(){
                this.director_list.push({"id":(this.director_list[this.director_list.length-1].id+1)});
            },
            removeItemDirector(id) {
                const index = this.director_list.findIndex(item => item.id === id)
                if (index !== -1) {
                    this.director_list.splice(index, 1)
                }
            },
            onChange(name){
                this.error[name]="";
            },
            submitAccount(){
                let is_valid = true;
                let self = this;
                this.isLoading = true;

                if(!this.$refs['companyInfo'].validate()){
                    console.log("company info belum valid");
                    is_valid = false;
                }

                if(!this.$refs['businessAddress'].validate()){
                    console.log("Business address belum valid");
                    is_valid = false;
                }

                if(!this.$refs['registeredAddress'].validate()){
                    console.log("register address belum valid");
                    is_valid = false;
                }

                for(let i=0;i<this.director_list.length;i++){
                    let ref = 'director'+this.director_list[i].id;
                    if(!this.$refs[ref][0].validate()){
                        console.log("director belum valid");
                        is_valid = false;
                    }
                }
                
                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    if(!this.$refs[ref][0].validate()){
                        console.log("beneficiary belum valid");
                        is_valid = false;
                    }
                }

                if(!this.agree){
                    is_valid = false;
                    console.log("agree belum valid");
                    this.error.agree = "must be checked";
                }

                if(is_valid){
                    CreateAccount.createType({"userType":5}).then(response => {
                        const data = response.data.data;
                        self.uploadPhoto(data);
                    }).catch(err => {
                        this.checkError(err);
                    });
                }
                else{
                    this.isLoading = false;
                }
            },
            uploadPhoto(account){
                console.log("=== account ===");
                console.log(account);
                this.account = account;
                this.$refs['companyInfo'].uploadFile(account);

                for(let i=0;i<this.director_list.length;i++){
                    let ref = 'director'+this.director_list[i].id;
                    this.$refs[ref][0].uploadFile(account);
                }
                
                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    this.$refs[ref][0].uploadFile(account);
                }
            },
            fileUploaded(){
                let director_completed = true;
                let beneficiary_completed = true;
                let have_failed = false;
                
                for(let i=0;i<this.director_list.length;i++){
                    let ref = 'director'+this.director_list[i].id;
                    if(this.$refs[ref][0].success==null){
                        director_completed = false;
                    }
                    if(this.$refs[ref][0].success === false){
                        have_failed = true;
                    }
                }
                
                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    if(this.$refs[ref][0].success==null){
                        beneficiary_completed = false;
                    }
                    if(this.$refs[ref][0].success === false){
                        have_failed = true;
                    }
                }

                if(
                    this.$refs['companyInfo'].success!=null &&
                    director_completed &&
                    beneficiary_completed
                ){
                    if(
                        this.$refs['companyInfo'].success === false ||
                        have_failed === true
                    ){
                        this.isLoading = false;
                    }
                    else if(
                        this.$refs['companyInfo'].success === true &&
                        have_failed === false
                    ){
                        this.submitData();
                    }
                }
            },
            submitData(){

                let companyInfo = this.$refs['companyInfo'];
                let businessAddress = this.$refs['businessAddress'];
                let registeredAddress = this.$refs['registeredAddress'];

                let params = {
                    "accountId":this.account.accountId,
                    "userNo":""+this.account.userNo,
                    "orgRegister":companyInfo.file.orgRegister,
                    "otherAccessories":companyInfo.file.otherAccessories,
                    "registerCountry":registeredAddress.params.country_code,
                    "name":companyInfo.params.name,
                    "enName":companyInfo.params.enName,
                    "orgRegisterNo":companyInfo.params.orgRegisterNo,
                    "registerDate":companyInfo.params.registerDate,
                    "registerAmt":parseFloat(companyInfo.params.registerAmt),
                    "registerProvince":registeredAddress.params.state_code,
                    "registerCity":registeredAddress.params.city_name,
                    "registerAddress":registeredAddress.params.address,
                    "country":businessAddress.params.country_code,
                    "province":businessAddress.params.state_code,
                    "city":businessAddress.params.city_name,
                    "address":businessAddress.params.address,
                    "postcode":businessAddress.params.postal_code,

                    "directorName":[],
                    "directorBirthDate":[],
                    "directorIdNo":[],
                    "directorIdType":[],
                    "directorIdFront":[],
                    "directorIdReverse":[],
                    "directorIdHold":[],
                    "directorCertExpiryDate":[],
                    "directorCountryCode":[],
                    "directorProvince":[],
                    "directorCity":[],
                    "directorArea":[],
                    "directorAddress":[],

                    "beneficiaryIdFront":[],
                    "beneficiaryIdReverse":[],
                    "beneficiaryIdType":[],
                    "beneficiaryIdNo":[],
                    "beneficiaryName":[],
                    "beneficiaryBirthDate":[],
                    "beneficiaryCertExpiryDate":[],
                    "beneficiaryCountry":[],
                    "beneficiaryProvince":[],
                    "beneficiaryCity":[],
                    "beneficiaryArea":[],
                    "beneficiaryAddress":[],
                    "beneficiaryShareholderRatio":[],
                };

                for(let i=0;i<this.director_list.length;i++){
                    let ref = 'director'+this.director_list[i].id;
                    params['directorCountryCode'].push(this.$refs[ref][0].params.directorCountry);
                    params['directorIdType'].push(this.$refs[ref][0].params.directorIdType);
                    params['directorIdFront'].push(this.$refs[ref][0].file.directorIdFront);
                    params['directorIdReverse'].push(this.$refs[ref][0].file.directorIdReverse);
                    params['directorIdHold'].push(this.$refs[ref][0].file.directorIdHold);
                    params['directorIdNo'].push(this.$refs[ref][0].params.directorIdNo);
                    params['directorName'].push(this.$refs[ref][0].params.directorName);
                    params['directorBirthDate'].push(this.$refs[ref][0].params.directorBirthDate);
                    params['directorCertExpiryDate'].push(this.$refs[ref][0].params.directorCertExpiryDate);
                    params['directorProvince'].push(this.$refs[ref][0].params.directorProvince);
                    params['directorCity'].push(this.$refs[ref][0].params.directorCity);
                    params['directorArea'].push(null);
                    params['directorAddress'].push(this.$refs[ref][0].params.directorAddress);
                }

                for(let i=0;i<this.beneficary_list.length;i++){
                    let ref = 'beneficiary'+this.beneficary_list[i].id;
                    params['beneficiaryIdFront'].push(this.$refs[ref][0].file.beneficiaryIdFront);
                    params['beneficiaryIdReverse'].push(this.$refs[ref][0].file.beneficiaryIdReverse);
                    params['beneficiaryIdType'].push(this.$refs[ref][0].params.beneficiaryIdType);
                    params['beneficiaryIdNo'].push(this.$refs[ref][0].params.beneficiaryIdNo);
                    params['beneficiaryName'].push(this.$refs[ref][0].params.beneficiaryName);
                    params['beneficiaryBirthDate'].push(this.$refs[ref][0].params.beneficiaryBirthDate);
                    params['beneficiaryCertExpiryDate'].push(this.$refs[ref][0].params.beneficiaryCertExpiryDate);
                    params['beneficiaryCountry'].push(this.$refs[ref][0].params.beneficiaryCountry);
                    params['beneficiaryProvince'].push(this.$refs[ref][0].params.beneficiaryProvince);
                    params['beneficiaryCity'].push(this.$refs[ref][0].params.beneficiaryCity);
                    params['beneficiaryArea'].push(this.$refs[ref][0].params.beneficiaryArea);
                    params['beneficiaryAddress'].push(this.$refs[ref][0].params.beneficiaryAddress);
                    params['beneficiaryShareholderRatio'].push(this.$refs[ref][0].params.beneficiaryShareholderRatio);
                }

                console.log("=== parameter ===");
                console.log(params);

                CreateAccount.otherRegion(params).then(response => {
                    const data = response.data.data;
                    this.isLoading = false;
                    this.$swal({
                        icon: 'success',
                        title: 'success',
                        showConfirmButton: true,
                    }).then((result) => {
                        window.parent.location.href = location.protocol+"//"+window.location.hostname;
                    });
                }).catch(err => {
                    this.checkError(err);
                });

            },
            togglePopup(){
                this.showPopup=!this.showPopup;
            },
            addBeneficiary(){
                this.beneficary_list.push({"id":(this.beneficary_list[this.beneficary_list.length-1].id+1)});
            },
            removeItem(id) {
                const index = this.beneficary_list.findIndex(item => item.id === id)
                if (index !== -1) {
                    this.beneficary_list.splice(index, 1)
                }
            },
            removeImage($event){
                console.log($event);
            },
            captureFile($event) {
                console.log($event);
            },
            toggleCamera(current_take) {
                this.current_take = current_take;
                this.$refs['take-picture'].toggleCamera(current_take);
            },
            takePhoto($event){
               console.log($event);
            },
            getMessage: function (key) {
                return this.$t(key)
            },
            checkError(err){
                let self = this;
                try{
                    this.isLoading = false;
                    const response = err.response;  
                    if(response.status == 400){
                        console.log(response.data);
                        if(typeof response.data.message === 'string'){
                            this.$swal({
                                icon: 'info',
                                html:response.data.message,
                                showConfirmButton: true,
                                confirmButtonText: self.getMessage('OK')
                            });
                        }
                        else{
                            if(response.data.message['errorMsg']){
                                this.$swal({
                                    icon: 'info',
                                    html:response.data.message['errorMsg'],
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                            else{
                                let ret = [];
                                let companyInfo = this.$refs['companyInfo'];
                                let businessAddress = this.$refs['businessAddress'];
                                let registeredAddress = this.$refs['registeredAddress'];

                                Object.keys(response.data.message).forEach((key) => {
                                    if(typeof companyInfo.error[key] !== "undefined"){
                                        companyInfo.error[key] = error;
                                    }
                                    else if(typeof businessAddress.error[key] !== "undefined"){
                                        businessAddress.error[key] = error;
                                    }
                                    else if(typeof registeredAddress.error[key] !== "undefined"){
                                        registeredAddress.error[key] = error;
                                    }
                                    
                                    if(key!="accountId"){
                                        ret.push(error);
                                    }
                                });

                                this.$swal({
                                    icon: 'info',
                                    html:ret.join("<br>"),
                                    showConfirmButton: true,
                                    confirmButtonText: self.getMessage('OK')
                                });
                            }
                        }
                    }      
                    else if(response.status == 401 && response.data.name == "Unauthorized"){
                            localStorage.removeItem("token");
                            localStorage.removeItem("member");
                            localStorage.removeItem("isFirstTime");
                            this.$router.push({ 
                                path: '/login', 
                            });
                    }
                    else{
                        if(localStorage.getItem("token")){
                            var msg = (response.data)?response.data.message:err.message;
                            this.$notify({
                                type: 'warn',
                                text: msg
                            })
                        }
                    }
                }catch(e){
                    console.log(err);
                }
            }
        }
    };
  </script>
